<template>
    <div v-if="is_load">
        <PacmanLoader v-if="false" />
        <MiniLoader />
    </div>
    <div v-else-if="access_denied">
        <h2>הגישה נדחתה</h2><br />
        נראה שאין לך הרשאות לצפות בעמוד זה.<br />
        במידה וקיבלת הודעה זאת בטעות, אנא צור קשר עם מנהלי האתר.
    </div>
    <div class="" v-else-if="store.is_login">
        <DataTable class="display" :columns="columns" :data="rows" ref="table" :options="{
            language: store.dataTable.language,
            lengthMenu: store.dataTable.lengthMenu,
            iDisplayLength: store.dataTable.iDisplayLength,
            buttons: store.dataTable.buttons,
            order: [0, 'desc'],
            responsive: true,
            dom: 'Bftip'
        }">
            <thead>
                <tr>
                    <th>תפריט</th>
                    <th>קטגוריה</th>
                    <th>שם מנה</th>
                    <th>מספר רכיבים</th>
                    <th>מחיר עלות</th>
                    <th>מחיר ללקוח</th>
                    <th>רווח</th>
                    <th>פעולות</th>
                </tr>
            </thead>
        </DataTable>

    </div>
    <div v-else>
        <NotLogin />
    </div>
</template>
<style scoped>
@import 'datatables.net-dt';
@import "//cdn.datatables.net/buttons/1.5.1/css/buttons.dataTables.min.css";
</style>
<script>
//import { ref } from 'vue';
import axios from 'axios'
import PacmanLoader from '@/components/loaders/PacmanLoader.vue';
import MiniLoader from '@/components/loaders/MiniLoader.vue';
import { store } from '@/store'
import { log, showPrice } from '@/utils.js'
import jQuery from "jquery";
import DataTable from 'datatables.net-vue3'
import DataTablesLib from 'datatables.net';
import 'datatables.net-responsive';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';

const $ = jQuery;
window.$ = $;



DataTable.use(DataTablesLib);
export default {
    el: 'ReservationList',
    components: {
        PacmanLoader,
        MiniLoader,
        DataTable,
    },
    mounted() {

        this.firstDataLoad();
        $(document).on('click', 'table button.edit', function() {
           window.open(store.api_url + '/crud/product_ingredient/'+$(this).data("id"), '_blank');
        });

    },
    computed: {
    },

    data() {
        return {
            store,
            tender: {},
            error: {},
            storage: {},
            is_load: true,
            access_denied: false,
            menus: [],
            statuses: [],
            factories: [],
            rows: [],
            columns: [
                { data: 'menu_name' },
                { data: 'mc_name' },
                { data: 'product_name' },
                { data: 'ingredients_count' },
                { data: 'product_cost' },
                { data: 'product_price' },
                { data: 'product_profit' },
                { data: 'actions' },
            ],
        }
    },
    methods: {
        firstDataLoad: function () {
            this.rows = [];

            let formData = new FormData();
            formData.append('key', sessionStorage.getItem('key'));
            axios.post(store.api_url + '/product/get_product_cost', formData).then(response => {
                let res = response.data.data;



                Object.values(res.product_cost).forEach((obj) => {

                    /*Object.assign(obj, {menu_name:  res.menus[obj.menu_id].menu_name});
                    Object.assign(obj, {product_name:  obj.product_name});
                    Object.assign(obj, {product_price:  obj.product_price});
                    Object.assign(obj, {product_cost:  obj.product_cost});
                    Object.assign(obj, {product_profit:  obj.product_profit});*/
                    this.rows.push({
                        menu_name: res.menus[obj.menu_id],
                        mc_name: res.menu_categories[obj.mc_id],
                        product_name: obj.product_name,
                        ingredients_count: obj.ingredients_count,
                        product_cost: showPrice(obj.product_cost),
                        product_price: showPrice(obj.product_price),
                        product_profit: showPrice(obj.product_profit),
                        actions: `
                        <div class="action_btn">
                            <button class="btn btn-default edit" title="עריכת הזמנה" data-id="${obj.product_id}">
                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"/></svg>
                            </button>
                            </div>
                            `,
                    });



                });
                this.is_load = false;


            }).catch(function (error) {
                log(error);
            });
        },
        test: function () {
            this.rows = [];

        },

    }
}


</script>
